import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function StatusGridDropdown({ onChangeDropdown, modelName, required, selectedValue, showLabel, autoFocus, onBlur, openMenuOnFocus }) {
    const [selectedStatusOption, setSelectedStatusOption] = useState([]);
    const [getStatusOptions, setStatusOptions] = useState([]);
    const [statusChanged, setStatusChanged] = useState(false);
    
    function handleChange(e, actionMeta) {
        setSelectedStatusOption(e);
        setStatusChanged(true);
        onChangeDropdown(e, actionMeta);
    };

    const fetchStatus = async () => {
        try {
            let statusDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/statuslist", { params: statusDetails });
            if (response.status === 200) {
                setStatusDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setStatusDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.StatusId, label: p.StatusName, name: 'Status', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setStatusOptions(allModuleOpt);
        setSelectedStatusOption(allModuleOpt.filter(x => x.value === selectedValue));
    }

    useEffect(() => {
        fetchStatus();
    }, []);
    return (
        <>
            <Select
                className="GridDropdown"
                name={modelName}
                value={selectedStatusOption ? selectedStatusOption : []}
                isClearable
                options={getStatusOptions || [] }
                onChange={handleChange}
                onBlur={onBlur}
                autoFocus={autoFocus}
                openMenuOnFocus={openMenuOnFocus}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: 32,
                      height: 32,
                      fontSize: '0.85rem',
                      borderColor: state.isFocused ? '#2684FF' : '#ccc',
                      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                      '&:hover': {
                        borderColor: '#2684FF',
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: 32,
                      padding: '0 8px',
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: 32,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999, // make sure dropdown appears above modals/tables
                    }),
                  }}
                />
        </>
                
    )
}

export default StatusGridDropdown